import {
    EuiBreadcrumbs,
    EuiButton,
    EuiForm,
    EuiLoadingContent,
    EuiPageContent,
    EuiPageContentHeader,
    EuiPageContentHeaderSection,
    EuiPanel,
    EuiSpacer,
    EuiTitle
} from "@elastic/eui";
import {Formik, FormikHelpers} from "formik";
import _ from "lodash";
import {observer} from "mobx-react-lite";
import React, {Fragment, useContext, useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {
    approveTrasnferorder,
    cancelTransferOrder,
    OrderFormValues,
    payTransferOrder,
    rejectTransferOrder
} from "../../../app/models/order";
import {Store} from "../../../app/stores/store-root";
import {Beneficiary} from "./order-form-beneficiary-section";
import CurrencyExchangeType from "./order-form-currency-exchange-type";
import Remitter from "./order-form-remitter-section";
import TransferTypeSection from "./order-form-transfer-type";
import {orderFormSchema} from "./order-form-validation";
import {Ticket} from "../../../app/models/Ticket";
import {GetActionsForOrderStatus, OrderFormActions} from "./order-form-actions";
import OrderFormRelatedTickets from "./order-form-related-tickets";
import OrderFormPayNotes from "./order-form-pay-notes";


type OrderFormProps = {
    Order: OrderFormValues,
    ReadOnly: boolean,
    Loading: boolean,
    Tickets: Ticket[],
    ShowActions: boolean,
    Navigation: any[],
    Title: string,
    CloseTicket: (ticket: Ticket) => void,
    CancelOrder: (order: OrderFormValues) => void,
    RejectOrder: (order: OrderFormValues) => void,
    SubmitOrder: (order: OrderFormValues) => Promise<void>,
    ShowBeneficiaryFields: boolean
    PayOrder: (order: OrderFormValues) => Promise<void>,
    ApproveOrder: (order: OrderFormValues) => Promise<void>,
    MakeOrderInprogrees: (order: OrderFormValues) => Promise<void>
}

const OrderForm = ({
                       Order,
                       ReadOnly,
                       Loading,
                       ShowActions,
                       Navigation,
                       Title,
                       CloseTicket,
                       CancelOrder,
                       RejectOrder,
                       SubmitOrder,
                       ShowBeneficiaryFields,
                       PayOrder,
                       ApproveOrder,
                       MakeOrderInprogrees
                   }: OrderFormProps) => {
    const [order, setOrder] = useState<OrderFormValues>(Order);
    const [loading, setloading] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [readOnly, setReadOnly] = useState(false);
    const [tickets, setTickets] = useState<Ticket[]>([]);
    const store = useContext(Store);
    const history = useHistory();
    const actions = GetActionsForOrderStatus(Order, store)
    const [selectedAction, setSelectedAction] = useState<string>('');


    const onActionChanged = (value: any) => {
        setSelectedAction(value.target.value);
    }

    //Load Exchange types
    useEffect(() => {
        setloading(true);

    }, [store.Exchanges, store.Lookups]);

    const disableSubmitButton = () => {
        if (isSubmitting)
            return true;
        if (ShowActions && !selectedAction && !store.Users.isSupervisor)
            return true;
        if (!ShowActions && ReadOnly)
            return true
        return false;
    }

    const [form, setForm] = useState<FormikHelpers<OrderFormValues> | undefined>(undefined);
    const onFormSubmit = (values: OrderFormValues, helpers: FormikHelpers<OrderFormValues>) => {

        setForm(helpers);
        console.log(values);
        console.log('onSubmit Selected actoion', selectedAction)
        switch (selectedAction) {
            case OrderFormActions.Empty.value:
                onSave(values);
                break;
            case  OrderFormActions.Approve.value:
                onApprove(values)
                break;
            case OrderFormActions.Reject.value:
                onReject(values);
                break;
            case OrderFormActions.Cancel.value:
                onCancel(values);
                break;
            case OrderFormActions.Pay.value:
                onPay(values);
                break;
            case OrderFormActions.Save.value:
                onSave(values);
                break;
            case OrderFormActions.InProgress.value:
                onOrderInprogress(values)
                break;
        }
        /* setIsSubmitting(true);

         values.RemitterPhone = values.RemitterPhone.replace(/\+/g, '00');
         values.BeneficiaryPhone = values.BeneficiaryPhone.replace(/\+/g, '00');

         SubmitOrder(values).then(() => {
             setIsSubmitting(false);
         })*/
    };


    const onSave = (values: OrderFormValues) => {
        values.RemitterPhone = values.RemitterPhone.replace(/\+/g, '00');
        values.BeneficiaryPhone = values.BeneficiaryPhone.replace(/\+/g, '00');
        console.log("onSave - Received Values ", values)
        if (values.SendingCurrencyCode != values.ReceivingCurrencyCode) {

            console.log("On Save - Sending Currency != Recieving")
            values.SettlementAmount =(values.SendingAmount!! * values.AgencyRate!!)
            values.ProfitInERN = values.SettlementAmount-values.ReceivingAmount!!;
            console.log("On Save - USD to ERN", store.Exchanges.USD_To_ERN)
            if (store.Exchanges.USD_To_ERN) {
                if (store.Exchanges.USD_To_ERN.AgencyRate) {
                    console.log("Profit in ERN ", values.ProfitInERN)
                    values.ProfiteInUSD = values.ProfitInERN / store.Exchanges.USD_To_ERN.AgencyRate;
                    console.log("Profit in USD ", values.ProfiteInUSD)
                    values.EquavilantInUSD = values.ReceivingAmount!! / store.Exchanges.USD_To_ERN.AgencyRate
                    values.Commission = 0.25 * values.ProfiteInUSD

                    console.log("On Save Calculated values", values)
                }
            }
        } else if (values.Fees)
            values.Commission = values.Fees!! * 0.25


        SubmitOrder(values).then(() => {
            setIsSubmitting(false);
        });
    }

    const onCancel = (values: OrderFormValues) => {
        //setIsSubmitting(true);
        const order: OrderFormValues = cancelTransferOrder(values, store);
        CancelOrder(order);
    };

    const onReject = (values: OrderFormValues) => {
        //setIsSubmitting(true);
        const order: OrderFormValues = rejectTransferOrder(values, store)
        RejectOrder(order);
    };

    const onPay = (values: OrderFormValues) => {
        const order: OrderFormValues = payTransferOrder(values, store);
        store.Orders.SetCurrentOrder(order);
        //PayOrder(order)
        history.push('/invoice');
    }

    const onApprove = (values: OrderFormValues) => {
        const order: OrderFormValues = approveTrasnferorder(values, store);
        ApproveOrder(order);
    }

    const onOrderInprogress = (values: OrderFormValues) => {
        //Todo: review the In progress Payment flow
        const order: OrderFormValues = payTransferOrder(values, store);
        MakeOrderInprogrees(order)
    }

    if (Loading)
        return (
            <div className={"space-y-10"}>
                <EuiLoadingContent lines={10}/>
                <EuiLoadingContent lines={10}/>
            </div>
        )
    //Todo: make the beneficiary Id info Mandatory
    return (
        <Fragment>
            <div>
                <Formik
                    initialValues={Order}
                    onSubmit={onFormSubmit}
                    enableReinitialize={true}
                    validationSchema={orderFormSchema}
                >
                    {(formik) => (
                        <Fragment>
                            <EuiPageContent>
                                <EuiBreadcrumbs
                                    breadcrumbs={Navigation}
                                    truncate={false}
                                    aria-label="An example of EuiBreadcrumbs"
                                />
                                <EuiSpacer size="xs"/>
                                <EuiPageContentHeader>
                                    <EuiPageContentHeaderSection>
                                        <EuiTitle size="l">
                                            <h1>{Title}</h1>
                                        </EuiTitle>
                                    </EuiPageContentHeaderSection>
                                </EuiPageContentHeader>
                            </EuiPageContent>
                            <EuiSpacer/>
                            <OrderFormRelatedTickets tickets={tickets} onCloseTicket={CloseTicket}/>
                            <EuiSpacer/>
                            <EuiForm
                                isInvalid={!formik.isValid && formik.submitCount > 0}
                                error={_.values(formik.errors)}>
                                <form onSubmit={formik.handleSubmit}>
                                    <Fragment>
                                        <OrderFormPayNotes FormActions={actions} ShowAction={ShowActions}
                                                           ShowBeneficiaryInfoFields={ShowBeneficiaryFields}
                                                           OnActionChanged={onActionChanged}/>

                                        <EuiPanel>
                                            <CurrencyExchangeType readonly={ReadOnly || isSubmitting}/>
                                            <TransferTypeSection readonly={ReadOnly || isSubmitting}/>
                                            <Remitter readonly={ReadOnly || isSubmitting}/>
                                            <Beneficiary readonly={ReadOnly || isSubmitting}/>
                                            <div className="space-x-8 flex justify-end">
                                                <EuiButton
                                                    size="s"
                                                    fill
                                                    type={"submit"}
                                                    isDisabled={disableSubmitButton()}
                                                    isLoading={isSubmitting}
                                                    data-test-subj={'submit-order-form'}
                                                >
                                                    Submit
                                                </EuiButton>
                                                <EuiButton
                                                    size="s"
                                                    type={"button"}
                                                    onClick={() => history.push("/")}
                                                >
                                                    Back to dashboard
                                                </EuiButton>
                                            </div>
                                        </EuiPanel>
                                    </Fragment>
                                </form>
                            </EuiForm>
                        </Fragment>
                    )}
                </Formik>
            </div>
        </Fragment>
    );
};

export default observer(OrderForm);
